import { Flex } from '@rebass/grid';

const Row = Flex;

Row.defaultProps = {
  mx: -3,
};

export default Row;
